import { create } from 'zustand';
import { ICallRequestsStore } from './types';
import { appointmentsApi } from '@/API';
import { useToastStore } from '@/stores/toast';
import { ECallRequestStatus, TCallRequestCamel } from '@/types';
import { convertKeys } from '@/utils/common';

export const useCallRequestsStore = create<ICallRequestsStore>((set, get) => ({
  callRequests: [],

  getPendingCallRequests: async () => {
    const response = await appointmentsApi.getPendingCallRequests();
    set({ callRequests: convertKeys(response.data.data) });
  },

  createCallRequest: async (appointmentId, userInstitutionRoleId) => {
    const response = await appointmentsApi.createCallRequest(
      convertKeys({ appointmentId, userInstitutionRoleId }, 'snake'),
    );
    get().applyCallRequest(convertKeys(response.data.data));
  },

  acceptCallRequest: async (id) => {
    const response = await appointmentsApi.acceptCallRequest(id);
    const callRequest: TCallRequestCamel = convertKeys(response.data.data);
    get().applyCallRequest(callRequest);
    return callRequest;
  },

  declineCallRequest: async (id) => {
    const response = await appointmentsApi.declineCallRequest(id);
    get().applyCallRequest(convertKeys(response.data.data));
  },

  applyCallRequest: (callRequest) =>
    set(({ callRequests }) => {
      const others = callRequests.filter(({ id }) => id !== callRequest.id);
      return {
        callRequests:
          callRequest.status === ECallRequestStatus.PENDING
            ? [...others, callRequest]
            : others,
      };
    }),

  clearCallRequests: () => {
    const { removeToast } = useToastStore.getState();
    get().callRequests.forEach(({ id }) => removeToast(id));
    set({ callRequests: [] });
  },
}));
